export enum BANNER_MESSAGE_STATUSES {
  Info = "info",
  Critical = "critical",
  Warning = "warning",
  Success = "success",
}
